import React, { useState, useRef, useEffect } from "react";
import Button from '@mui/material/Button';
import { Container, Col, Row } from "reactstrap";
import { useNavigate, useLocation, Link} from "react-router-dom";
import logo from '../../../Assets/Images/logo.png';
import TextField from '@mui/material/TextField';
import { useForm } from "react-hook-form";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import ConstantData from "../../../Utils/Constant";
import SubscriptionFooter from "../../Common/SubscriptionFooter";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import {Helmet} from "react-helmet";
import PasswordStrengthMeter from '../Common/PasswordStrengthMeter/PasswordStrengthMeter';
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { Config } from "../../../Utils/Config";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AccountSubscription = (props) => {
  const navigate = useNavigate();
  const { handleSubmit, control, watch, register } = useForm();
  const password = useRef({});
  password.current = watch("password", "");
  const [userDetails, setUserDetails] = React.useState({});
  const [firstNameErr, setFirstNameErr] = React.useState('');
  const [lastNameErr, setLastNameErr] = React.useState('');
  const [emailErr, setEmailErr] = React.useState('');
  const [pwdErr, setPwdErr] = React.useState('');
  const [confirmPwdErr, setConfirmPwdErr] = React.useState('');
  const [phoneErr, setPhoneErr] = React.useState('');
  const [isLoading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [snackClr, setSnackClr] = React.useState('');
  const [snackMsg, setSnackMsg] = React.useState('');
  const lookupKeyMap = {
    "free": 1,
    "basic": 3,
    "unlimited-annually": 3,
    "unlimited-quarterly": 7,
    "single-prepaid-report": 4,
    "five-prepaid-report": 8,
    "ten-prepaid-report": 5,
  };
  const packageTextMap = {
    "single-prepaid-report": "Create Account to Single Market Report",
    "five-prepaid-report": "Create Account to Five Market Bundle",
    "ten-prepaid-report": "Create Account to Ten Market Bundle",
  };
  const priceDetails = props.packageFullData ? props.packageFullData : [];
  const [userInfo, setuserInfo] = useState({
    password: '',
  });

  const search = useLocation().search;
  const packageChosen = new URLSearchParams(search).get('type');
  const onePrepaidPrice = priceDetails && priceDetails.length > 0 ? priceDetails.filter(data=>data.id === ConstantData.lookupKeyMap.singleReport)[0].currency + priceDetails.filter(data=>data.id === ConstantData.lookupKeyMap.singleReport)[0].price : null;
  const fivePrepaidPrice = priceDetails && priceDetails.length > 0 ? priceDetails.filter(data=>data.id === ConstantData.lookupKeyMap.fiveReport)[0].currency + priceDetails.filter(data=>data.id === ConstantData.lookupKeyMap.fiveReport)[0].price : null;
  const tenPrepaidPrice = priceDetails && priceDetails.length > 0 ? priceDetails.filter(data=>data.id === ConstantData.lookupKeyMap.tenReport)[0].currency + priceDetails.filter(data=>data.id === ConstantData.lookupKeyMap.tenReport)[0].price : null;

  const onChangeValidation = (e) => {
    // First name validation
    if (e.target.name === 'firstName') {
      var regName = /^[A-Za-z\/\s\.'-]+$/;
      var name = e.target.value;
      if (name.length === 0) {
        setFirstNameErr('First name required');
      } else {
        if (!regName.test(name)) {
          setFirstNameErr('Invalid character');
        } else {
          setFirstNameErr('');
        }
      }
    }

    // Last name validation
    if (e.target.name === 'lastName') {
      var regName = /^[A-Za-z\/\s\.'-]+$/;
      var name = e.target.value;
      if (name.length === 0) {
        setLastNameErr('Last name required');
      } else {
        if (!regName.test(name)) {
          setLastNameErr('Invalid character');
        } else {
          setLastNameErr('');
        }
      }
    }

    // Email validation
    if (e.target.name === 'email') {
      var regName = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
      // var regName = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
      var name = e.target.value;
      if (name.length === 0) {
        setEmailErr('Email address required');
      } else {
        if (!regName.test(name)) {
          setEmailErr('Email address is invalid');
        } else {
          setEmailErr('');
        }
      }
    }

    // Password validation
    if (e.target.name === 'password') {
      var regName = /^(.{0,}(([a-zA-Z][^a-zA-Z])|([^a-zA-Z][a-zA-Z])).{4,})|(.{1,}(([a-zA-Z][^a-zA-Z])|([^a-zA-Z][a-zA-Z])).{3,})|(.{2,}(([a-zA-Z][^a-zA-Z])|([^a-zA-Z][a-zA-Z])).{2,})|(.{3,}(([a-zA-Z][^a-zA-Z])|([^a-zA-Z][a-zA-Z])).{1,})|(.{4,}(([a-zA-Z][^a-zA-Z])|([^a-zA-Z][a-zA-Z])).{0,})$/;
      var name = e.target.value;
      if (name.length === 0) {
        setPwdErr('Password required');
      } else {
        if (!regName.test(name)) {
          setPwdErr('Passwords are case-sensitive.');
        } else {
          if (name.length <= 5) {
            setPwdErr('Your Password must be 6 characters');
          } else if (name.length >= 26) {
            setPwdErr('Your Password maximum limit is 25 characters');
          } else {
            if (userDetails.confirmPassword && userDetails.confirmPassword !== name) {
              setConfirmPwdErr('Password does not match.');
              setPwdErr('');
            } else {
              setPwdErr('');
              setConfirmPwdErr('');
            }
          }
        }
      }
    }

    // Confirm password validation
    if (e.target.name === 'confirmPassword') {
      var name = e.target.value;
      if (name.length === 0) {
        setConfirmPwdErr('Confirm password required');
      } else {
        if (name === userInfo.password) {
          setConfirmPwdErr('');
        } else {
          setConfirmPwdErr('Password does not match');
        }
      }
    }


    //phone
    if (e.target.name === 'phone') {
      var string = e.target.value;
      var replacedString = e.target.value.replace(/-/g, "").replace("(", "").replace(")", "");
      var spaceRemovedStr = string.replace(/ /g, '');
      var numericRegex = /^([0-9]*)$/;
      var valid = numericRegex.exec(replacedString);

      if (valid) {
        string = replacedString;
        var regex = replacedString.length === 10 ? /^([^\s]{3})([^\s]{3})+([^\s]{4})+$/g : replacedString.length === 11 ? /^([^\s]{3})([^\s]{3})+([^\s]{5})+$/g : replacedString.length === 12 ? /^([^\s]{3})([^\s]{3})+([^\s]{6})+$/g : replacedString.length === 13 ? /^([^\s]{3})([^\s]{3})+([^\s]{7})+$/g : replacedString.length === 14 ? /^([^\s]{3})([^\s]{3})+([^\s]{8})+$/g : replacedString.length === 15 ? /^([^\s]{3})([^\s]{3})+([^\s]{9})+$/g : /^([^\s]{3})([^\s]{3})+([^\s]{9})+$/g;
        var match = regex.exec(string);
        if (match) {
          match.shift();
          match[0] = "(" + match[0] + ")";
          string = match.join("-");
          if (replacedString.length >= 16) {
            setPhoneErr('Invalid number');
          } else {
            setPhoneErr('')
          }
        } else {
          if (replacedString.length >= 16) {
            setPhoneErr('Invalid number');
          } else {
            setPhoneErr('');
          }
        }

      } else if (spaceRemovedStr.length > 0) {
        setPhoneErr('Invalid number');
      }
      if (string === "") {
        setPhoneErr('Phone is required');
      }
    }
    setUserDetails({ ...userDetails, [e.target.name]: e.target.name === 'phone' ? string : e.target.value });

  }

  const formSubmission = () => {
    setLoading(true);
      let inputData={
           "firstname": userDetails.firstName,
        "lastname": userDetails.lastName,
        "company": userDetails.companyName ? userDetails.companyName : '',
        "emailaddress": userDetails.email,
        "password": userInfo.password,
        "confirmpassword": userDetails.confirmPassword,
        //"lookupkey": packageChosen === "free" ? priceDetails && priceDetails[0].lookupkey : packageChosen === "basic" ? priceDetails && priceDetails[1].lookupkey : packageChosen === "unlimited" ? priceDetails && priceDetails[1].lookupkey : packageChosen === "single-prepaid-report" ? priceDetails && priceDetails[2].lookupkey : packageChosen === "ten-prepaid-report" ? priceDetails && priceDetails[3].lookupkey : null,
        "lookupkey": priceDetails && lookupKeyMap[packageChosen] !== undefined? priceDetails.filter(data=>data.id === lookupKeyMap[packageChosen])[0]?.lookupkey: null,
        "phone": userDetails.phone}
        apiCommonTrigger("post",`${Config.API_URL}/subscription/add`,inputData)
      .then((res) => {
        // return res;
        if (res.status === 200) {
          if (res.data === "success") {
            setLoading(false);
            window.location.replace(res.headers.location);
          }
        }
        else{
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch(error => {
        setLoading(false);
        handlingCatchError(error, navigate);
      });
  }

  // Form submission
  const onHandleSubmit = () => {
    if (!firstNameErr && !lastNameErr && !emailErr && !isError && !confirmPwdErr && !phoneErr && userDetails.firstName && userDetails.lastName && userDetails.email && userDetails.phone && userInfo.password && userDetails.confirmPassword) {
      setLoading(true);
      apiCommonTrigger("get" , Config.API_URL + "/home/validatesignupemail/" , [userDetails.email])
      .then((res) => {
        if (res.status === 200) {
          if (res.data.isexist === false) {
            setLoading(false);
            formSubmission();
          } else {
            setLoading(false);
            setEmailErr('Email already linked to an existing RV Parks account. Please use a different email address.')
          }
        }
        else{
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        setLoading(false);
        handlingCatchError(err, navigate);
      });
     

    } else {
      if (firstNameErr === '' && !userDetails.firstName) {
        setFirstNameErr('Please fill out this field');
      }
      if (lastNameErr === '' && !userDetails.lastName) {
        setLastNameErr('Please fill out this field');
      }
      if (emailErr === '' && !userDetails.email) {
        setEmailErr('Please fill out this field');
      }
      if (isError === '' && !userInfo.password) {
        setError('Please fill out this field');
      }
      if (confirmPwdErr === '' && !userDetails.confirmPassword) {
        setConfirmPwdErr('Please fill out this field');
      }
      if (phoneErr === '' && !userDetails.phone) {
        setPhoneErr('Please fill out this field');
      }
    }
  }

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
          return;
      }

      setOpen(false);
  };

  useEffect(() => { 
    document.documentElement.scrollTo(0, 0);
  }, []);

  const [isError, setError] = useState('');
  const handleChangePassword = (e) => {
    let password  = e.target.value;
    setuserInfo({
      ...userInfo,
      password:e.target.value
    });
    setError('');
    let capsCount, smallCount, numberCount, symbolCount
    if (password.length < 4) {
      setError("Password must be minimum 4 characters include one UPPERCASE, lowercase, number and special character: @$! % * ? &");
      return;
    }
    else {
      capsCount = (password.match(/[A-Z]/g) || []).length
      smallCount = (password.match(/[a-z]/g) || []).length
      numberCount = (password.match(/[0-9]/g) || []).length
      symbolCount = (password.match(/\W/g) || []).length
      if (capsCount < 1) {
        setError("Must contain one UPPERCASE letter");
        return;
      }
      else if (smallCount < 1) {
        setError("Must contain one lowercase letter");
        return;
      }
      else if (numberCount < 1) {
        setError("Must contain one number");
        return;
      }
      else if (symbolCount < 1) {
        setError("Must contain one special character: @$! % * ? &");
        return;
      }

      if (userDetails.confirmPassword && userDetails.confirmPassword !== password) {
        setConfirmPwdErr('Password does not match.');
        setError('');
        return;
      }else{
        setError('');
        setConfirmPwdErr('');
        return;
      }
    }
  }
  
  const [isStrength, setStrength] = useState(null);
  const dataHandler = async (childData) => {
    setStrength(childData);
  }

  return (
    <React.Fragment>
      <Helmet>
          <title>{packageChosen === "single-prepaid-report" ? 'RV Parks & Campgrounds Property and Market Analysis Reports | RVParkIQ' : packageChosen === 'free' ? 'RV Parks & Campgrounds Market Explorer FREE Sign Up | RVParkIQ' : packageChosen.startsWith("unlimited") ? 'RV Parks & Campgrounds Market Explorer PRO Sign Up | RVParkIQ' : ''}</title>
          <meta name="description" content="Find investment opportunities, get ownership information, analyze properties & run market reports. RVParkIQ is the only market intelligence platform for RV Park & Campground investors" />
      </Helmet>
      {isLoading ? (
        <div className="loader-wrap">
          <div className="default-page loading loading-center"></div>
        </div>
      ) : (
        ""
      )}
      <div className='subscription-wrapper' style={{ position: 'relative', height: '100vh' }}>
        <Container fluid>
          <Row>
            <Col className='part-left' style={{ height: '100vh', maxHeight: '100vh', minHeight: '100vh' }}>
              <Container>
                <Row>
                  <Col xs={12} className='logo-subscription mt-2 text-center'>
                    <Link to={"/"}><img src={logo} alt="RVParkIQ" className='rvparks-logo' /></Link>
                  </Col>

                  <Col xs={12} className="modal-custom-popup mt-2">
                    <form id='RVParkIQ_account_subscription_form'>
                      {!packageChosen.startsWith("unlimited") ? packageTextMap[packageChosen] && (
                        <h3 className="text-center">{packageTextMap[packageChosen]}</h3>
                      ) :
                        <h3 className="text-center">Create Your {packageChosen === 'free' ? 'Free' : packageChosen.startsWith("unlimited") ? 'Pro' : ''} Account Now</h3>}
                      <Row className="mt-4">
                        <Col>
                          <TextField
                            label="First Name"
                            id="outlined-required"
                            fullWidth
                            value={userDetails.firstName ? userDetails.firstName : ''}
                            name="firstName"
                            onChange={(e) => onChangeValidation(e)}
                            error={!!firstNameErr}
                            helperText={firstNameErr ? firstNameErr : null}
                            margin="normal"
                            required
                            className="textbox-custom"
                          />
                        </Col>
                        <Col>
                          <TextField
                            label="Last Name"
                            id="outlined-required"
                            fullWidth
                            value={userDetails.lastName ? userDetails.lastName : ''}
                            name="lastName"
                            onChange={(e) => onChangeValidation(e)}
                            error={!!lastNameErr}
                            helperText={lastNameErr ? lastNameErr : null}
                            margin="normal"
                            required
                            className="textbox-custom"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <TextField
                            label="Email Address"
                            id="outlined-required"
                            fullWidth
                            value={userDetails.email ? userDetails.email : ''}
                            name="email"
                            onChange={(e) => onChangeValidation(e)}
                            error={!!emailErr}
                            helperText={emailErr ? emailErr : null}
                            type="email"
                            margin="normal"
                            required
                            className="textbox-custom"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <TextField
                            label="Company Name"
                            id="outlined-required"
                            fullWidth
                            value={userDetails.companyName ? userDetails.companyName : ''}
                            name="companyName"
                            onChange={(e) => onChangeValidation(e)}
                            margin="normal"
                            className="textbox-custom"
                          />
                        </Col>
                        <Col>
                          <TextField
                            label="Phone Number"
                            id="outlined-password-input"
                            size="normal"
                            margin="normal"
                            fullWidth
                            value={userDetails.phone ? userDetails.phone : ''}
                            name="phone"
                            onChange={(e) => onChangeValidation(e)}
                            error={!!phoneErr}
                            helperText={phoneErr ? phoneErr : null}
                            required
                            className="textbox-custom"
                          // type="number"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                        {/* {isError !== null && (
                          <p className="errors" style={{fontSize:'11px'}}> - {isError}</p>
                        )} */}
                          <TextField
                            label="Password"
                            id="outlined-password-input"
                            fullWidth
                            value={userInfo.password ? userInfo.password : ''}
                            name="password"
                            // onChange={(e) => onChangeValidation(e)}
                            onChange={(e) => handleChangePassword(e)}
                            error={!!isError}
                            helperText={isError ? isError : null}
                            type="password"
                            margin="normal"
                            required
                            className="textbox-custom"
                          />
                          <PasswordStrengthMeter password={userInfo.password} actions={dataHandler}/>
                        </Col>
                        <Col>
                          <TextField
                            label="Confirm Password"
                            id="outlined-password-input"
                            margin="normal"
                            fullWidth
                            value={userDetails.confirmPassword ? userDetails.confirmPassword : ''}
                            name="confirmPassword"
                            onChange={(e) => onChangeValidation(e)}
                            error={!!confirmPwdErr}
                            helperText={confirmPwdErr ? confirmPwdErr : null}
                            type="password"
                            required
                            className="textbox-custom"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} className="text-center mt-3 mb-4">
                          <Button onClick={() => onHandleSubmit()} className="market-btn">Continue</Button>
                        </Col>
                        <p style={{ fontSize: '11px', textAlign: 'center' }}>By providing your email address and clicking 'Continue' above, you agree to RVParkIQ <Link to={"/terms-of-service"} target="_blank">Terms of Service</Link> and <Link to={"/privacy-policy"} target="_blank">Privacy Policy</Link>. You can change your communication preferences anytime.</p>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <SubscriptionFooter />
                        </Col>
                      </Row>
                      {/* <Button onClick={() => props.closeChild(false)} className="reset-opt">Cancel</Button> */}
                    </form>
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col className='part-right'>
              <Container>
                {packageChosen === 'free' ?
                  <Row>
                    <Col className="mt-2 free-subscription" xs={12}>
                      <h3>Try Market Explorer for FREE</h3>
                      <p>Access the Market Explorer platform for RV parks and campgrounds now for free (no credit card required). With a free account to Market Explorer, you can view limited property information on RV parks and demographic details on any market. Continue your analysis with the purchase of a detailed Market Report, available on-demand.</p>
                      <p>With your free account you get details on:</p>
                    </Col>
                    <Col xs={12} className="pt-2 pb-2">
                      <h5>RV Park Profile</h5>
                      <ul>
                        <li>Property Address</li>
                        {/* <li>Seasonality</li> */}
                      </ul>
                    </Col>
                    {/* <Col xs={12}>
                      <h5>Population Center Profile</h5>
                      <ul>
                        <li>RV Parks in the Market</li>
                        <li>Average price per Night</li>
                        <li>Population</li>
                        <li>Income per Capita</li>
                      </ul>
                    </Col> */}
                  </Row>
                  :
                  packageChosen === "basic" ?
                    <Row>
                      <Col xs={12} className="pricing-info mt-2">
                        <h3>Basic</h3>
                        <div className='pricing-value mb-3'>
                          Starting at <span>{priceDetails && priceDetails.length > 0 ? priceDetails.filter(data => data.id === 3)[0].currency + priceDetails.filter(data => data.id === 3)[0].price : ''}</span><em>/month</em>
                          <p>with annual subscription</p>
                        </div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                      </Col>
                      <Col xs={12} className="basic-features">
                        <h5>Full RV Park Profile</h5>
                        <ul>
                          <li>Property Details</li>
                          <li>Amenities and Features</li>
                          <li>Rate Details</li>
                          {/* <li>Marketing</li> */}
                          <li>Ownership</li>
                          <li>Valuation and Debt</li>
                          <li>Transaction History</li>
                        </ul>
                      </Col>
                      <Col xs={12} className="basic-features">
                        <h5>Market Dynamics Score</h5>
                        <ul>
                          <li>Market Demand Score</li>
                          <li>Market Supply Factors</li>
                        </ul>
                      </Col>
                      <Col xs={12} className="basic-features">
                        <h5>Full Population Center Profile</h5>
                        <ul>
                          <li>RV Parks in market</li>
                          <li>Average price per night</li>
                          <li>Average size of park</li>
                          {/* <li>RV Ownership in Market
                            <ul>
                              <li style={{fontSize:'11px'}}>Percentage of Households willing to go camping</li>
                            </ul>
                          </li> */}
                          {/* <li>Rental Availability</li> */}
                          <li>Population</li>
                          <li>Population density</li>
                          <li>Region Type</li>
                          <li>Income per capita</li>
                          {/* <li>Average Fuel Cost</li> */}
                          <li>Average Age</li>
                          <li>Age Cohorts</li>
                          {/* <li>Ethnicity</li>
                          <li>Ethnicity Cohorts</li>
                          <li>Gender Percentages</li> */}
                        </ul>
                      </Col>
                    </Row> :
                    packageChosen.startsWith("unlimited") ?
                      <Row>
                        <Col className="pricing-info mt-2" xs={12}>
                          <h3>Pro Subscription {packageChosen === "unlimited-annually"?"(Annually)":"(Quarterly)"}</h3>
                          <div className='pricing-value mb-3'>
                            Starting at <span>{priceDetails && priceDetails.length > 0 ? packageChosen === "unlimited-annually" ? priceDetails.filter(data => data.id === ConstantData.lookupKeyMap.annually)[0].currency + Math.floor(priceDetails.filter(data => data.id === ConstantData.lookupKeyMap.annually)[0].price / 12) : priceDetails.filter(data => data.id === ConstantData.lookupKeyMap.quarterly)[0].currency + Math.floor(priceDetails.filter(data => data.id === ConstantData.lookupKeyMap.quarterly)[0].price / 3) : ''}</span><em>/{priceDetails && priceDetails.length > 0 ? 'Month' : ''}</em>
                          </div>
                          <p>Get complete access to the entire application with the ability to create an unlimited number of market reports.</p>
                        </Col>
                        <Col xs={12} className="basic-features">
                          <h5>Full RV Park Profile</h5>
                          <ul>
                            <li>Property Details</li>
                            <li>Amenities and Features</li>
                            <li>Rate Details</li>
                            {/* <li>Marketing</li> */}
                            <li>Ownership</li>
                            <li>Valuation and Debt</li>
                            <li>Transaction History</li>
                            <li>Seasonality</li>
                          </ul>
                        </Col>
                        <Col xs={12} className="basic-features">
                          <h5>Market Dynamics Score</h5>
                          <ul>
                            <li>Market Demand Score</li>
                            <li>Market Supply Factors</li>
                          </ul>
                        </Col>
                        <Col xs={12} className="basic-features">
                          <h5>Full Population Center Profile</h5>
                          <ul>
                            <li>RV Parks in market</li>
                            <li>Average Price per Night</li>
                            <li>Average Size of Park</li>
                            {/* <li>RV Ownership in Market
                              <ul>
                              <li style={{fontSize:'11px'}}>Percentage of Households willing to go camping</li>
                            </ul>
                            </li> */}
                            {/* <li>Rental Availability</li> */}
                            <li>Population</li>
                            <li>Population density</li>
                            <li>Region Type</li>
                            <li>Income per Capita</li>
                            {/* <li>Average Fuel Cost</li> */}
                            <li>Average Age</li>
                            <li>Age Cohorts</li>
                            {/* <li>Ethnicity</li>
                            <li>Ethnicity Cohorts</li>
                            <li>Gender Percentages</li> */}
                          </ul>
                          <h5>Unlimited Market Analysis Reports</h5>
                        </Col>
                      </Row> :
                      packageChosen === "single-prepaid-report" || packageChosen === "ten-prepaid-report" || packageChosen === "five-prepaid-report" ?
                        <Row>
                          <Col className="pricing-info mt-2" xs={12}>
                            <h3 style={{ marginBottom: '8px' }}>{packageChosen === "ten-prepaid-report" ? 'Purchase 10 Market Bundle' : packageChosen === "five-prepaid-report" ? 'Purchase 5 Market Bundle' : 'Purchase a Single Market Report'}</h3>
                            <p className="summary-days">(30-day access to Market Explorer included)</p>
                            <div className='pricing-value mb-3'>
                            <span>{packageChosen === "ten-prepaid-report" ? tenPrepaidPrice : packageChosen === "five-prepaid-report" ? fivePrepaidPrice : onePrepaidPrice}</span>/{packageChosen === "ten-prepaid-report" ? 'ten market bundle' : packageChosen === "five-prepaid-report" ? 'five market bundle' : 'single market report'}
                            </div>
                            <p>Receive a detailed market report via email or download it immediately after purchase. Perform a deeper analysis on the market and come back any time within 30 days to view the data again or download additional customizable reports. Gain access to our proprietary scoring, where you can view the average percentage of people willing to camp within a market as determined by you.</p>
                            <p>You will enter your market’s location after purchase. To preview a market first, <Link to={"/preview-market"} style={{color: '#fff'}}>click here</Link>. Included in each report:</p>
                          </Col>
                          <Col xs={12} className="basic-features">
                            <h5>Full RV Park Profile</h5>
                            <ul>
                              <li>Property Details</li>
                              <li>Amenities and Features</li>
                              <li>Rate Details</li>
                              {/* <li>Marketing</li> */}
                              <li>Ownership</li>
                              <li>Valuation and Debt</li>
                              <li>Transaction History</li>
                              <li>Seasonality</li>
                            </ul>
                          </Col>
                          <Col xs={12} className="basic-features">
                            <h5>Market Dynamics Score</h5>
                            <ul>
                              <li>Market Demand Score</li>
                              <li>Market Supply Factors</li>
                            </ul>
                          </Col>
                          <Col xs={12} className="basic-features">
                            <h5>Full Population Center Profile</h5>
                            <ul>
                              <li>RV Parks in market</li>
                              <li>Average price per night</li>
                              <li>Average size of park</li>
                              {/* <li>RV Ownership in Market</li> */}
                              {/* <li>Rental Availability</li> */}
                              <li>Population</li>
                              <li>Population Density</li>
                              <li>Region Type</li>
                              <li>Income per capita</li>
                              {/* <li>Average Fuel Cost</li> */}
                              <li>Average Age</li>
                              <li>Age Cohorts</li>
                              {/* <li>Ethnicity</li>
                              <li>Ethnicity Cohorts</li>
                              <li>Gender Percentages</li> */}
                            </ul>
                          </Col>
                        </Row> :
                        ''}
              </Container>
            </Col>
          </Row>
        </Container>
      </div>
      <Snackbar open={open} autoHideDuration={2000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={handleClose} severity={snackClr} sx={{ width: '100%' }}>
              {snackMsg}
          </Alert>
      </Snackbar>
    </React.Fragment>
  )
}
export default AccountSubscription;